define([
	"dojo/_base/declare",
	"csi/heading/NumberController",
	"csi/utility/coreUtility",
	"csi/xml"
], function(declare, NumberController, {isDefined}, xml) {

	return declare(NumberController, {
		// Object: object with API for relevant Increment information
		//_incrementData: null,

		// If this Dimension should display as two dimensional
		//_isDisplayTwoDim: null,

		// If this Dimension should display as two dimensional
		//_isDisplayTwoDim: null,

		//baseSizeDim1Index: null,
		//baseSizeDim2Index: null,
		//dim1SizeCount: null,
		//dim2SizeCount: null,

		onStart: function() {
			var scDimension = this.getNode();
			this._incrementData = this.widget.getIncrementData();

			if (this._incrementData && this._incrementData.isTwoDim()) {
				this._isDisplayTwoDim = this.widget.displayTwoDimension(scDimension);
				this.baseSizeDim1Index = this._incrementData.getDim1BaseIndex();
				this.baseSizeDim2Index = this._incrementData.getDim2BaseIndex();
				this.dim1SizeCount = this._incrementData.getDim1SizeCount();
				this.dim2SizeCount = this._incrementData.getDim2SizeCount();
			}
		},

		process: function() {
			// summary: if value is position and before the base size, then negate it (and vice-versa)
			var	bsIndex = this.ren._getBaseSizeIndex(this.getContext());

			if ((this.keyContainer < bsIndex) && (this.newValue > 0) && !this._isPositiveValue()) {
				this.newValue = -this.newValue;
			}

			this.inherited(arguments);
		},

		_getIndicesOfNextCellsAwayFromBase: function(/*Integer*/index, /*Integer*/baseIndex, /*Double[]*/doubles) {
			// Find the next increment and recalculate it to preserve the Relative/Absolute mode value

			var indices = [];

			if (this._isDisplayTwoDim) {
				// 2D Dimension
				var iDim1 = this._incrementData.getDim1Index(index);
				var iDim2 = this._incrementData.getDim2Index(index);
				var x;

				if (iDim1 == this.baseSizeDim1Index) {
					// On base column : 3 cells
					var y;

					// Next non-empty cell Vertically
					if (iDim2 < this.baseSizeDim2Index) {
						for (y = iDim2 - 1; y >= 0; y--) {
							if(this._checkAndPushTo(iDim1, y, doubles, indices))
								break;
						}
					} else {
						for (y = iDim2 + 1; y < this.dim2SizeCount; y++) {
							if(this._checkAndPushTo(iDim1, y, doubles, indices))
								break;
						}
					}
				}

				if (iDim1 <= this.baseSizeDim1Index) {
					// Cell to the left
					for (x = iDim1 - 1; x >= 0; x--) {
						if(this._checkAndPushTo(x, iDim2, doubles, indices))
							break;
					}
				}

				if (iDim1 >= this.baseSizeDim1Index) {
					// Cell to the right
					for (x = iDim1 + 1; x < this.dim1SizeCount; x++) {
						if(this._checkAndPushTo(x, iDim2, doubles, indices))
							break;
					}
				}
			} else {
				// 1D Dimension
				var	maxIndex = this._getMaxIndex();

				if (index > baseIndex && index +1 <= maxIndex) {
					indices.push(index +1);
				} else if (index < baseIndex && index -1 >= 0){
					indices.push(index -1);
				}
			}

			return indices;
		},

		_getMaxIndex: function() {
			return this._incrementData.isTwoDim() && !this._isDisplayTwoDim ?
					this.dim1SizeCount -1 : this._incrementData.sizes.length -1;
		},

		_checkAndPushTo : function(/*Integer*/iDim1, /*Integer*/iDim2, /*Double[]*/doubles, /*Integer[]*/indices) {
			var i = this._incrementData._mapDim1ToDim2Indices[iDim1][iDim2];
			if (i != undefined && i >= 0) {
				indices.push(i)
				return true;
			}
			return false;
		},

		_isValueChanged: function() {
			// summary: if blank dimension, then any value is a change
			if (this.getNode().Blanks) {
				// this function can be called later in the controller after the editNode is destroyed, so at that point
				// the endStatus will indicate if a valid value was entered; and we cannot test for "newValue" because
				// it is 0 even when edit field is left blank - we need to test the string value to see if it is empty or not
				const inlineEditValue = this.getInlineEditValue();
				return inlineEditValue === "" ? !!this.endStatus : true;
			}
			
			return this.inherited(arguments);
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: compute changes to increment and absolute values
			var	cn = this.inherited(arguments);

			// if dimension showing blanks and non-empty value entered, then set Blanks to false and refresh row
			if ((this.getInlineEditValue() !== "") && this.getNode().Blanks) {
				cn.changeAttribute("Blanks", xml.ATTR_BOOLEAN, false);
				this.bRefreshNode = true;
			}

			// adjust increment values to compensate for change to absolute value; make sure to also adjust cached values
			if (!this.ren.isIncrementDisplay(this._ctx)) {
				var	dDiff = this.newValue - this.oldValue;
				var obj = this.ren.getIncrementValues(this._ctx);
				var	value = {};

				obj.inc[this.keyContainer] += dDiff;
				obj.abs[this.keyContainer] += dDiff;
				value[this.keyContainer] = obj.inc[this.keyContainer];

				// Find the next increment cells and recalculate it to preserve the Relative/Absolute mode value
				var indicesAffectedCell = this._getIndicesOfNextCellsAwayFromBase(this.keyContainer, obj.bsIndex, obj.inc);
				var curIndex;
				if (indicesAffectedCell) {
					for (var i = 0; i < indicesAffectedCell.length; i++) {
						curIndex = indicesAffectedCell[i];
						obj.inc[curIndex] -= dDiff;
						obj.abs[curIndex] += dDiff;
						value[curIndex] = obj.inc[curIndex];
					}
				}

				cn.changeAttributeKeys(id, type, value);
			}

			return cn;
		},

		/**
		 * @override
		 * set value to 0 if newValue is null
		 */
		setNewValueOnChange(newValue) {
			if (isDefined(newValue)) {
				this.newValue = newValue || 0;
			}
		},
	});
});